import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';

/** maxIncome is null for the open-ended top bracket. Rates are ratios (0.1), not percentages. */
export interface TaxRateBracket {
  rate: number;
  minIncome: number;
  maxIncome: number | null;
}

/**
 * Net investment income tax: an extra rate on investment income once income reaches
 * thresholdIncome. TXS never folds this into its capital gains rates, so consumers add it.
 */
export interface NetInvestmentIncomeTax {
  rate: number;
  thresholdIncome: number;
}

export interface TaxRates {
  federalIncomeTaxRateBrackets: TaxRateBracket[];
  federalCapitalGainsRateBrackets: TaxRateBracket[];
  netInvestmentIncomeTax: NetInvestmentIncomeTax;
  stateIncomeTaxRateBrackets: TaxRateBracket[];
  stateEffectiveTaxRate: number;
  stateIsProgressive: boolean;
  stateTaxesRothConversion: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TaxRatesService {
  private readonly TAX_RATES_URL = environment.taxRatesUrl;

  constructor(private http: HttpClient) {}

  // filingStatus is the app's lowercase-hyphen form; the Lambda maps it to TXS's enum.
  async fetch(filingStatus: string, stateCode: string): Promise<TaxRates> {
    return firstValueFrom(
      this.http.post<TaxRates>(this.TAX_RATES_URL, { filingStatus, stateCode }),
    );
  }
}
